import React, { useCallback } from 'react';

import { Icon } from '@components';

import theme from '../../../themes/colors';

interface BusinessNameInfoBannerProps {
  onViewSample: () => void;
  variant?: 'default' | 'compact';
  text?: string;
}

const DEFAULT_TEXT =
  'Only the first 30 characters will be shown in SMS messages.';

const CONTAINER_BASE =
  'mt-2 flex items-center justify-start gap-2 bg-cofeeBlue25 px-3 py-2';

const VARIANT_STYLES = {
  compact: 'border border-cofeeGreyBlue200 rounded-lg min-h-11',
  default: 'border-l-6 border-l-cofeeBlue600 rounded min-h-12'
} as const;

const BusinessNameInfoBanner = ({
  onViewSample,
  variant = 'default',
  text = DEFAULT_TEXT
}: BusinessNameInfoBannerProps) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') onViewSample();
    },
    [onViewSample]
  );

  return (
    <div className={`${CONTAINER_BASE} ${VARIANT_STYLES[variant]}`}>
      <div className="flex items-start gap-1">
        <div className="size-5 min-w-5 shrink-0">
          <Icon
            name="alert-circle"
            stroke={theme.cofeeBlue600}
            size="medium"
            className="stroke-cofeeBlue600 stroke-[1.5px]"
            iconLoadingDelay={0}
          />
        </div>
        <p className="text-sm font-medium text-cofeeGreyBlue500">
          {text}
          <span
            className="ml-0.5 cursor-pointer font-medium text-cofeePrimary6"
            onClick={onViewSample}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
          >
            View sample
          </span>
        </p>
      </div>
    </div>
  );
};

export default BusinessNameInfoBanner;
